import { useSelector, shallowEqual } from 'react-redux';

import {
  selectFuelType,
  initialState as initialFuelTypeState
} from 'state/fuel-type/fuel-type-slice';

import {
  initialState as initialPeymentMethodState,
  selectPaymentMethod
} from 'state/payment-method/payment-method-slice';
import {
  selectElectricVehicle,
  initialState as initialElectricVehicleState
} from 'state/electric-vehicle/electric-vehicle-slice';

export const useHasInitialState = () => {
  const fuelType = useSelector(selectFuelType, shallowEqual);
  const electricVehicle = useSelector(selectElectricVehicle, shallowEqual);
  const paymentMethod = useSelector(selectPaymentMethod, shallowEqual);

  const fuel =
    fuelType.electric === initialFuelTypeState.electric &&
    fuelType.gas === initialFuelTypeState.gas;
  const ev =
    electricVehicle === initialElectricVehicleState.data.electricVehicle;
  const payment =
    paymentMethod === initialPeymentMethodState.data.paymentMethod;

  return {
    fuel,
    ev,
    payment
  };
};
